import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { DateTime } from 'luxon';
import api from '@/services/api';
import {
  USER_API,
  USER_SUCCESS,
  USER_ERROR,
  CHANGEPWD_API,
  CHANGEPWD_SUCCESS,
  CHANGEPWD_ERROR,
  SUBUSER_API,
  SUBUSER_SUCCESS,
  SUBUSER_ERROR,
  REQUESTS_API,
  REQUESTS_SUCCESS,
  REQUESTS_ERROR,
  REQUEST_API,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
  ROUTES_API,
  ROUTES_SUCCESS,
  ROUTES_ERROR,
  ROUTE_DETAILS_API,
  ROUTE_DETAILS_SUCCESS,
  ROUTE_DETAILS_ERROR,
  FLEETS_API,
  FLEETS_SUCCESS,
  FLEETS_ERROR,
  LOGIN_API,
  RESET_PASSWORD_API,
  LOGIN_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  LOGIN_ERROR,
  LOGOUT,
  UPDATE_CONTRACT,
  UPDATE_REQUEST,
  SELECT_SINGLE_CONTRACT,
  SELECT_ALL_CONTRACTS,
  UPDATE_CREDITS,
  TOGGLE_EXPAND_FLEET,
  SET_ROUTES_DATE_FROM,
  SET_ROUTES_DATE_TO,
} from './mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: {},
    subuser: {},
    selectedContractId: localStorage.getItem('selectedContractId') || null,
    fleets: [],
    requests: {},
    routes: {},
    expandedFleets: localStorage.getItem('expandedFleets') ? JSON.parse(localStorage.getItem('expandedFleets')) : {},
    routeDetails: [],
    routesDateFrom: DateTime.local().minus({ days: 1 }).startOf('day'),
    routesDateTo: DateTime.local().endOf('day')
  },
  mutations: {
    [UPDATE_CONTRACT](state, data) {
      for (let f in state.fleets) {
        if (state.fleets[f].id == data.fleetId) {
          for (let c in state.fleets[f].contracts) {
            if (state.fleets[f].contracts[c].id == data.contractId) {
              const contract = Object.assign({}, state.fleets[f].contracts[c]);
              contract.livemonitor.latitude = data.latitude;
              contract.livemonitor.longitude = data.longitude;
              contract.livemonitor.speed = data.speed;
              contract.livemonitor.alarmStatus = data.alarmStatus;
              contract.livemonitor.inputStatus = data.inputStatus;
              contract.livemonitor.online = data.online;
              contract.livemonitor.lastFixAt = data.lastFixAt;
              Vue.set(state.fleets[f].contracts, c, contract);
              break;
            }
          }
          break;
        }
      }
    },
    [USER_API](state) {
      state.status = 'loading';
    },
    [USER_SUCCESS](state, data) {
      state.status = 'success';
      state.user = data.user;
    },
    [USER_ERROR](state) {
      state.status = 'error';
    },
    [CHANGEPWD_API](state) {
      state.status = 'loading';
    },
    [CHANGEPWD_SUCCESS](state) {
      state.status = 'success';
      state.subuser.passwordExpired = false;
    },
    [CHANGEPWD_ERROR](state) {
      state.status = 'error';
    },
    [SUBUSER_API](state) {
      state.status = 'loading';
    },
    [SUBUSER_SUCCESS](state, data) {
      state.status = 'success';
      state.subuser = data.subuser;
    },
    [SUBUSER_ERROR](state) {
      state.status = 'error';
    },
    [REQUEST_API](state) {
      state.status = 'loading';
    },
    [REQUEST_SUCCESS](state, data) {
      state.status = 'success';
      // i dati della nuova request arrivano da pusher
      // Vue.set(state.requests, data.contractId,
      //   [data.request, ...state.requests[data.contractId]],
      // );
    },
    [REQUEST_ERROR](state) {
      state.status = 'error';
    },
    [REQUESTS_API](state) {
      state.status = 'loading';
    },
    [REQUESTS_SUCCESS](state, data) {
      state.status = 'success';
      Vue.set(state.requests, data.contractId, data.requests)
    },
    [REQUESTS_ERROR](state, contractId) {
      state.status = 'error';
      state.requests[contractId] = [];
    },
    [ROUTES_API](state) {
      state.status = 'loading';
    },
    [ROUTES_SUCCESS](state, data) {
      state.status = 'success';
      Vue.set(state.routes, data.contractId, data.routes)
    },
    [ROUTES_ERROR](state, contractId) {
      state.status = 'error';
      state.routes[contractId] = [];
    },
    [ROUTE_DETAILS_API](state) {
      state.status = 'loading';
    },
    [ROUTE_DETAILS_SUCCESS](state, data) {
      state.status = 'success';
      state.routeDetails = data.routeDetails;
    },
    [ROUTE_DETAILS_ERROR](state) {
      state.status = 'error';
      state.routeDetails = [];
    },
    [FLEETS_API](state) {
      state.status = 'loading';
    },
    [FLEETS_SUCCESS](state, data) {
      state.status = 'success';
      state.fleets = data.fleets.filter(fleet => fleet.contracts.length > 0);
    },
    [FLEETS_ERROR](state) {
      state.status = 'error';
      state.fleets = [];
    },
    [LOGIN_API](state) {
      state.status = 'loading';
    },
    [RESET_PASSWORD_API](state) {
      state.status = 'loading';
    },
    [LOGIN_SUCCESS](state, data) {
      state.status = 'success';
      state.token = data.token;
    },
    [RESET_PASSWORD_SUCCESS](state) {
      state.status = 'resetPasswordSuccess';
    },
    [LOGIN_ERROR](state) {
      state.status = 'error';
    },
    [LOGOUT](state) {
      state.status = '';
      state.user = {};
      state.subuser = {};
      state.fleets = {};
      state.token = '';
    },
    [SELECT_SINGLE_CONTRACT](state, contractId) {
      state.selectedContractId = contractId;
      localStorage.setItem('selectedContractId', contractId);
    },
    [SELECT_ALL_CONTRACTS](state) {
      state.selectedContractId = null;
      localStorage.removeItem('selectedContractId');
    },
    [UPDATE_CREDITS](state, credits) {
      state.user = { ...state.user, credits };
    },
    [TOGGLE_EXPAND_FLEET](state, fleetId) {
      Vue.set(state.expandedFleets, fleetId, !state.expandedFleets[fleetId]);
      localStorage.setItem('expandedFleets', JSON.stringify(state.expandedFleets));
    },
    [UPDATE_REQUEST](state, request) {
      let requests = state.requests[request.contractId] || [];
      let found = false;
      for (let i = 0; i < requests.length; i += 1) {
        if (requests[i].id === request.id) {
          requests = [...requests];
          requests[i] = request;
          found = true;
          break;
        }
      }
      if (!found) {
        requests = [request, ...requests];
      }
      Vue.set(state.requests, request.contractId, requests);
    },
    [SET_ROUTES_DATE_FROM](state, date) {
      state.routesDateFrom = date;
    },
    [SET_ROUTES_DATE_TO](state, date) {
      state.routesDateTo = date;
    },
  },
  actions: {
    request({ commit, getters }, payload) {
      return new Promise((resolve, reject) => {
        commit(REQUEST_API);
        const { command, parameters } = payload;
        const contractId = getters.selectedContract.id;
        const deviceId = getters.selectedContract.device.id;
        const subuserId = getters.subuser.id || null;
        api.request(contractId, deviceId, subuserId, command, parameters)
          .then((data) => {
            commit(REQUEST_SUCCESS, { contractId, request: data });
            resolve();
          })
          .catch((error) => {
            commit(REQUEST_ERROR);
            reject(error);
          });
      });
    },
    requests({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(REQUESTS_API);
        api.requests(payload.contractId)
          .then((data) => {
            commit(REQUESTS_SUCCESS, { contractId: payload.contractId, requests: data });
            resolve();
          })
          .catch((error) => {
            commit(REQUESTS_ERROR);
            reject(error, payload.contractId);
          });
      });
    },
    routes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(ROUTES_API);
        const { contractId, from, to } = payload;
        api.routes(contractId, from, to)
          .then((data) => {
            commit(ROUTES_SUCCESS, { contractId: payload.contractId, routes: data });
            resolve();
          })
          .catch((error) => {
            commit(ROUTES_ERROR);
            reject(error, payload.contractId);
          });
      });
    },
    exportRouteInXlsx({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const { contractId, from, to } = payload;
        api.exportRouteInXlsx(contractId, from, to)
          .then((data) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            resolve();
          })
          .catch((error) => {
            commit(ROUTES_ERROR);
            reject(error, payload.contractId);
          });
      });
    },
    routeDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(ROUTE_DETAILS_API);
        api.routeDetails(payload.routeId)
          .then((data) => {
            commit(ROUTE_DETAILS_SUCCESS, { routeDetails: data });
            resolve(data);
          })
          .catch((error) => {
            commit(ROUTE_DETAILS_ERROR);
            reject(error, payload.contractId);
          });
      });
    },
    user({ commit }) {
      return new Promise((resolve, reject) => {
        commit(USER_API);
        api.user()
          .then((data) => {
            commit(USER_SUCCESS, { user: data });
            resolve();
          })
          .catch((error) => {
            commit(USER_ERROR);
            reject(error);
          });
      });
    },
    changepwd({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(CHANGEPWD_API);
        const { oldPassword, newPassword, token } = payload;

        if(token == undefined || token == ""){
          api.changepwd(oldPassword, newPassword, token)
          .then(() => {
            commit(CHANGEPWD_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(CHANGEPWD_ERROR);
            reject(error);
          });
        } else {
          api.resetpwd(newPassword, token)
          .then(() => {
            commit(CHANGEPWD_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(CHANGEPWD_ERROR);
            reject(error);
          });
        }
      });
    },
    subuser({ commit }) {
      return new Promise((resolve, reject) => {
        commit(SUBUSER_API);
        api.subuser()
          .then((data) => {
            commit(SUBUSER_SUCCESS, { subuser: data });
            resolve();
          })
          .catch((error) => {
            commit(SUBUSER_ERROR);
            reject(error);
          });
      });
    },
    fleets({ commit }) {
      return new Promise((resolve, reject) => {
        commit(FLEETS_API);
        api.fleets()
          .then((data) => {
            commit(FLEETS_SUCCESS, { fleets: data });
            resolve();
          })
          .catch((error) => {
            commit(FLEETS_ERROR);
            reject(error);
          });
      });
    },
    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(LOGIN_API);
        api.login(payload.username, payload.password)
          .then((data) => {
            const { token } = data;
            localStorage.setItem('token', token);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            commit(LOGIN_SUCCESS, { token });
            resolve();
          })
          .catch((error) => {
            commit(LOGIN_ERROR);
            localStorage.removeItem('token');
            reject(error);
          });
      });
    },
    resetPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit(RESET_PASSWORD_API);

        console.log(payload.username);

        api.resetPassword(payload.username, process.env.NODE_ENV)
          .then((data) => {
            commit(RESET_PASSWORD_SUCCESS);
            resolve();
          })
          .catch((error) => {
            commit(RESET_PASSWORD_ERROR);

            reject(error);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit(LOGOUT);
        localStorage.removeItem('token');
        localStorage.removeItem('selectedContractId');
        delete axios.defaults.headers.common.Authorization;
        resolve();
      });
    },
  },
  getters: {
    routesDateFrom: state => state.routesDateFrom,
    routesDateTo: state => state.routesDateTo,
    requests: state => state.requests[state.selectedContractId] || [],
    routes: state => state.routes[state.selectedContractId] || [],
    isFleetExpanded: state => fleetId => !!state.expandedFleets[fleetId],
    expandedFleets: state => state.expandedFleets,
    selectedContract: (state, getters) => state.selectedContractId
      ? getters.contracts.filter(contract => contract.id == state.selectedContractId)[0]
      : null,
    isLogged: state => !!state.token,
    authStatus: state => state.status,
    fleets: state => state.fleets,
    user: state => state.user,
    subuser: state => state.subuser,
    filteredContracts: (state, getters) => state.selectedContractId
      ? getters.contracts.filter(contract => contract.id == state.selectedContractId)
      : getters.contracts,
    contracts: (state) => state.fleets.flatMap(fleet => {
      return fleet.contracts.map(contract => {
        return Object.assign(contract, {
          color: fleet.color.toLowerCase(),
          fleetId: fleet.id,
        });
      });
    }),
    contract: (state, getters) => contractId => {
      const contracts = getters.contracts.filter(contract => contract.id == contractId);
      return contracts.length > 0 ? contracts[0] : null;
    },
    requestInProgress: (state, getters) => command => {
      if (!state.selectedContractId) { return false; }

      const requests = getters.requests.filter(request => {
        return request.status < 3 && request.command === command;
      });

      return requests.length > 0;
    }
  },
});
